import { Button, Form, Input, Select, Space } from "antd";

import { useEffect, useState } from "react";

import TextArea from "antd/lib/input/TextArea";
import Price from "components/Price/price";
import useClientStore from "stores/clientStore";
import useProductStore from "stores/productStore";
import humanize from "utils/formate-status";

const Paymentform = ({
  submitHandler,
  submitLoader,
  editData,
  setVisible,
  confirmEditHandler,
}) => {
  const [form] = Form.useForm();
  const [currentFields, setCurrentfields] = useState([]);

  const [priceData, setPriceData] = useState("");
  const [clientList, setClientList] = useState([]);

  //productStore
  const products = useProductStore((state) => state.Products);

  const clients = useClientStore((state) => state.clients);

  useEffect(() => {
    if (editData) {
      form.setFieldsValue({
        item_price: Math.trunc(editData?.plan?.price?.item_price) || "",
        qty: editData?.plan?.price?.qty || "",
        discount_percentage: editData?.plan?.price?.discount_percentage || "",
        charges: Math.trunc(editData?.plan?.price?.charges) || "",
        taxes: editData?.plan?.price?.taxes.map((tax) => tax.title) || "",
        description: editData.description,
      });
    }

    console.log({ editData });

    const clientList = clients.map((client) => {
      return {
        label: ` ${client.name}   (${humanize(client.status)})`,
        value: client._id,
        key: client._id,
      };
    });

    setClientList(clientList);
  }, []);

  useEffect(() => {
    console.log(priceData);
  }, [priceData]);

  const onFinish = (values) => {
    if (editData) {
      console.log({ values });
      console.log({ priceData });
      console.log({ editData });

      const finalPayload = {};

      finalPayload.price = priceData;
      finalPayload.price.item_price =
        priceData?.item_price || editData?.plan?.price?.item_price;
      finalPayload.price.charges =
        priceData?.charges || editData?.plan?.price?.charges;
      finalPayload.payment_id = editData.payment_id;
      finalPayload.description = values.description;
      console.log(finalPayload, "Values");

      confirmEditHandler(finalPayload);
    } else {
      values.price = priceData;
      submitHandler(values);
    }
  };

  const fuzzyFilter = (query) => {
    if (!query) {
      // If no query, show all clients sorted alphabetically
      const allClients = clients.map(client => ({
        label: `${client.name} (${humanize(client.status)})`,
        value: client._id,
        key: client._id
      })).sort((a, b) => a.label.localeCompare(b.label));
      
      setClientList(allClients);
      return;
    }
  
    const queryLower = query.toLowerCase();
    const results = clients
      .map(client => {
        const name = client.name.toLowerCase();
        let priority = -1; // Default to no match
        
        // Highest priority: Starts with the search term
        if (name.startsWith(queryLower)) {
          priority = 2;
        }
        // Second priority: Any word starts with the search term
        else if (name.split(' ').some(word => word.toLowerCase().startsWith(queryLower))) {
          priority = 1;
        }
        // Lowest priority: Contains the search term
        else if (name.includes(queryLower)) {
          priority = 0;
        }
  
        return priority >= 0 ? {
          client,
          priority
        } : null;
      })
      .filter(Boolean) // Remove null entries
      .sort((a, b) => {
        // First sort by priority
        if (b.priority !== a.priority) {
          return b.priority - a.priority;
        }
        // Then alphabetically within each priority group
        return a.client.name.localeCompare(b.client.name);
      })
      .map(result => ({
        label: `${result.client.name} (${humanize(result.client.status)})`,
        value: result.client._id,
        key: result.client._id
      }));
  
    setClientList(results);
  };

  return (
    <Form
      form={form}
      key={editData?._id}
      name="dynamic_form_nest_item"
      onFinish={onFinish}
      autoComplete="off"
    >
      {!editData && (
        <Space>
          <Form.Item
            labelCol={{ span: 24, offset: 0 }}
            style={{ width: "21rem", transition: ".5s" }}
            name="client"
            label="Client"
            rules={[{ required: true }]}
            // disabled={editData}
            hidden={editData}
          >
            <Select
              disabled={editData}
              style={{ width: "100%", maxWidth: "100%" }}
              showSearch
              placeholder="Select a client"
              optionFilterProp="children"
              // onChange={onClientChange}
              onSearch={(input) => {
                fuzzyFilter(input);
              }}
              options={clientList}
              filterOption={(input, client) => {
                return true;
              }}
            ></Select>
          </Form.Item>

          <Form.Item
            hidden={editData}
            // disabled={editData}
            labelCol={{ span: 24, offset: 0 }}
            style={{ width: "21rem", transition: ".5s", marginLeft: ".5rem" }}
            name="type"
            label="Type"
            rules={[{ required: true }]}
            initialValue={"other"}
          >
            <Select
              disabled={editData}
              // hidden={editData}
              style={{ width: "100%", maxWidth: "100%" }}
              defaultValue={"other"}
              placeholder="Select a client"
              optionFilterProp="children"
              // onChange={onClientChange}
            >
              <Select.Option value="other">Other</Select.Option>
              <Select.Option value="plan_creation">Plan Creation</Select.Option>
              <Select.Option value="additional_plan">
                Additional Plan
              </Select.Option>
              <Select.Option value="plan_recurring">
                Plan Recurring
              </Select.Option>
              <Select.Option value="sale">Sale</Select.Option>
              <Select.Option value="rent_creation">Rent Creation</Select.Option>
              <Select.Option value="rent_recurring">
                Rent Recurring
              </Select.Option>
              <Select.Option value="defective_repair_cost">
                Defective Repair Cost
              </Select.Option>
              <Select.Option value="onsite_repair_cost">
                Onsite Repair Cost
              </Select.Option>
            </Select>
          </Form.Item>
        </Space>
      )}

      <Price priceEditData={editData} setPriceData={setPriceData} />

      <Form.Item
        labelCol={{ span: 24, offset: 0 }}
        label="Description"
        name="description"
        initialValue={""}
      >
        <TextArea />
      </Form.Item>

      {currentFields?.map((field, index) => (
        <Form.Item
          labelCol={{ span: 24, offset: 0 }}
          key={field._id}
          label={editData ? field?.name.toUpperCase() : field?.name}
          name={field?.name?.toLowerCase()}
          // hidden={field.name.toLowerCase() == "template"}
          rules={[
            {
              required: true,
              message: "Missing ",
            },
          ]}
          initialValue={field?.value || ""}
        >
          <Input type={field.data_type} />
        </Form.Item>
      ))}

      <Form.Item
        wrapperCol={{
          offset: 16,
          span: 10,
        }}
      >
        <Space size={8}>
          <Button key={editData._id} onClick={() => setVisible(false)}>
            Cancel
          </Button>
          {editData ? (
            <Button type="primary" htmlType="submit" loading={submitLoader}>
              Update
            </Button>
          ) : (
            <Button type="primary" htmlType="submit" loading={submitLoader}>
              Submit
            </Button>
          )}
        </Space>
      </Form.Item>
    </Form>
  );
};

export default Paymentform;
